import { createContext, useContext, useRef, type ReactNode } from "react";

export type PendingSave = { flush: () => unknown; leave?: () => unknown; commitTyping?: () => void };

export type PendingSaves = Set<PendingSave>;

const PendingSavesContext = createContext<PendingSaves | null>(null);

export const usePendingSavesRegistry = (): PendingSaves => useRef<PendingSaves>(new Set()).current;

export const PendingSavesProvider = ({ registry, children }: { registry: PendingSaves; children: ReactNode }) => (
  <PendingSavesContext.Provider value={registry}>{children}</PendingSavesContext.Provider>
);

export const usePendingSaves = (): PendingSaves | null => useContext(PendingSavesContext);

export const leavePendingSaves = async (registry: PendingSaves | null): Promise<void> => {
  if (!registry) return;
  await Promise.all([...registry].map((pending) => pending.leave?.()));
};

export const flushPendingSaves = async (registry: PendingSaves | null): Promise<void> => {
  if (!registry) return;
  registry.forEach((pending) => pending.commitTyping?.());
  await Promise.all([...registry].map((pending) => pending.flush()));
};
